import component from './PhGear.vue_vue&type=script&lang.js';
export { default } from './PhGear.vue_vue&type=script&lang.js';
import { render } from './PhGear.vue_vue&type=template&id=14d0665e&lang.js';

component.render = render;
